import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

import "../css/InfoSucursales.css";
import { HomeMap } from "./HomeMap.jsx";
import { ItemSucursal } from "./ItemSucursal.jsx";
import DataCities from "../assets/json/Ciudades.json";
import BotonVolver from "../assets/images/VolverBoton.png";
import Separador from "../assets/images/Separador.png";
import { CiudadModal } from "./CiudadModal.jsx";
import { ItemDetalles } from "./ItemDetalles.jsx";
import cerrar from "../assets/images/Vectorclose.png";
import filtro from "../assets/images/filtro.png";
import logoBU from "../assets/images/Logo Portal BU.png";
import lupa from "../assets/images/Vector1.png";
import lupa2 from "../assets/images/Vector2.png";
import volverflecha from "../assets/images/Vector3.png";
export const InfoSucursales = () => {
  const [CiudadData, setCiudad] = useState([]);
  const [Locations, setLocations] = useState([]);
  const [LocationsCopy, setLocationsCopy] = useState([]);
  const [FiltroActivado, setFiltro] = useState(false);
  const [DetallesActivado, setDetallesActivado] = useState(false);
  const [Detalles, setDetalles] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [Servicios, setServicios] = useState([]);
  const contenedorCiudades = useRef();
  const coook = new Cookies();
  const [BusquedaCiudad, setBusquedaCiudad] = useState("");
  const [ciudadBuscada, setCiudadBuscada] = useState("");
  const [checkedValues, setValue] = useState([]);
  const [ciudadBuscada1, setCiudadBuscada1] = useState("");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/ciudades`
      );
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setModalShow(true);
    document.getElementById("dropdown1").style.display = "none";
    document.getElementById("dropdown").style.display = "none";
  }, []);
  const openItem = () => {
    document.getElementById("infoCiudades").style.display = "block";
  };

  const FiltroCiudad1 = DataCities.filter((el) => {
    let myVar1 = document.body.contains(document.getElementById("dropdown1"));
    if (myVar1) {
      document.getElementById("dropdown1").style.display = "block";
    } else {
    }
    if (ciudadBuscada1 === "") {
      if (myVar1) {
        document.getElementById("dropdown1").style.display = "none";
      } else {
      }
      return el;
    } else {
      return el.Ciudad.toUpperCase().includes(ciudadBuscada1);
    }
  });
  const FiltroCiudad2 = DataCities.filter((el) => {
    let myVar2 = document.body.contains(document.getElementById("dropdown"));
    if (myVar2) {
      document.getElementById("dropdown").style.display = "block";
    } else {
    }

    if (ciudadBuscada === "") {
      if (myVar2) {
        document.getElementById("dropdown").style.display = "none";
      } else {
      }
      return el;
    } else {
      return el.Ciudad.toUpperCase().includes(ciudadBuscada);
    }
  });

  const handleChange = (event) => {
    if (event.type === "change") {
      const { value, checked } = event.target;
      if (checked) {
        setValue((pre) => [...pre, value]);
      } else {
        setValue((pre) => {
          return [...pre.filter((skill) => skill !== value)];
        });
      }
    } else {
    }
  };

  const obtenerOficinasTerminaciones = (checkedValues) => {
    const oficinasTerminacionesSet = new Set();

    if (checkedValues.length === 0 || checkedValues.length === 6) {
      oficinasTerminacionesSet.add("on");
      oficinasTerminacionesSet.add("ty");
      oficinasTerminacionesSet.add("rio");
      oficinasTerminacionesSet.add("pagas");
      oficinasTerminacionesSet.add("Oro*");
    } else {
      for (let i = 0; i < checkedValues.length; i++) {
        const value = checkedValues[i];

        switch (value) {
          case "a1":
            oficinasTerminacionesSet.add("on");
            break;

          case "a2":
            oficinasTerminacionesSet.add("ty");
            oficinasTerminacionesSet.add("rio");
            oficinasTerminacionesSet.add("pagas");
            break;

          case "b1":
            oficinasTerminacionesSet.add("Oro*");
            break;

          case "c1":
            oficinasTerminacionesSet.add("ty");
            break;

          case "c2":
            oficinasTerminacionesSet.add("rio");
            break;

          case "c3":
            oficinasTerminacionesSet.add("pagas");
            break;

          default:
            break;
        }
      }
    }

    return Array.from(oficinasTerminacionesSet);
  };

  const aplicarFiltros = () => {
    setLocations([]);
    setBusquedaCiudad("");
    setFiltro(false);
    ocultarFiltros();
    setCiudadBuscada1("");

    const terminaciones = obtenerOficinasTerminaciones(checkedValues);
    const sucursalesFiltradas = LocationsCopy.filter((name) => {
      for (const terminacion of terminaciones) {
        if (
          name.Convenio.endsWith(terminacion) ||
          name.Servicio.endsWith(terminacion)
        ) {
          return true;
        }
      }
      return false;
    });

    setLocations(sucursalesFiltradas);
    openItem();
  };
  const Quitarfiltros = () => {
    const checkboxes = document.querySelectorAll(".checkboxFiltro");
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    setValue([]);
  };

  const buscarCiudad = (event, searchTerm) => {
    if (event.type === "click") {
      setCiudadBuscada(searchTerm);
    } else {
    }
  };
  const buscarCiudad1 = (event, searchTerm1) => {
    if (event.type === "click") {
      setCiudadBuscada1(searchTerm1);
    } else {
    }
  };

  const ocultarFiltros = () => {
    document.getElementById("contenedor-buscar").style.display = "block";
    document.getElementById("dropdown1").style.display = "none";
    document.getElementById("dropdown").style.display = "none";
    let input = document.getElementById("buscarOficinas");
    input.value = "";
    setCiudadBuscada1("");
    ocultarMenuFiltros();
  };

  const verMenuFiltros = () => {
    closeItem();
    document.getElementById("contenedor-filtros").style.display = "block";
    let input = document.getElementById("buscarOficinas");
    input.placeholder = "Filtros";
    input.value = "Filtros";
    input.disabled = true;
    document.getElementById("contenedor-buscar").style.display = "none";
  };
  const ocultarMenuFiltros = () => {
    document.getElementById("contenedor-filtros").style.display = "none";
    let input = document.getElementById("buscarOficinas");
    input.disabled = false;
    input.value = "";
    input.placeholder = "Buscar municipio";
    openItem();
  };

  const closeItem = () => {
    document.getElementById("infoCiudades").style.display = "none";
  };
  const ElegirCiudad = (DataCiudad) => {
    setLocations([]);
    setBusquedaCiudad("");
    setCiudad(DataCiudad);
    setFiltro(false);
    ocultarFiltros();
    setCiudadBuscada1("");
    axios
      .get(
        process.env.REACT_APP_ENDPOINT +
          "/getlocations?location=" +
          DataCiudad.QueryCiudad +
          "*" +
          DataCiudad.Ciudad
      )
      .then(function (res) {
        setServicios(res.data.Servicios);
        setLocations(res.data);
        setLocationsCopy(res.data);
        coook.set("idNextPage", res.data.next_page_token);
      });
    openItem();
    setModalShow(false);
  };

  const Next = () => {
    if (coook.get("idNextPage") !== "undefined") {
      axios
        .get(
          process.env.REACT_APP_ENDPOINT +
            "/getnextpage?next=" +
            coook.get("idNextPage")
        )
        .then(function (resultParam) {
          var arr = [];
          resultParam.data.results.forEach((element, index) => {
            if (
              resultParam.data.results[index].name ===
              "Giros y Finanzas, Western Union"
            ) {
              arr.push(resultParam.data.results[index]);
            }
          });
          setLocations((prevState) => [...prevState, ...arr]);
          coook.set("idNextPage", resultParam.data.next_page_token);
        });
    }
  };

  const ScrollDiv = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      Next();
    }
  };

  const ElegirSucursal = (propiedadesSucursal) => {
    setDetalles(propiedadesSucursal);

    setDetallesActivado(false);
    setDetallesActivado(true);
  };

  const FiltroCiudad = DataCities.filter((el) => {
    if (BusquedaCiudad === "") {
      return el;
    } else {
      return el.Ciudad.toUpperCase().includes(BusquedaCiudad);
    }
  });

  return (
    <div>
      <div className="infoCiudades" id="infoCiudades">
        <br />
        <div className="container-close-button">
          <button
            className="CloseButton boton-cerrar-info-sucursales"
            style={{ backgroundImage: `url(${cerrar})` }}
            onClick={() => closeItem()}
          />
        </div>
        <div className="ElementosC">
          <div className="row ">
            <div className="col-6">
              <p className="text-filtro-ciudad" style={{ fontFamily: "lato" }}>
                Filtrar Sucursales
              </p>
            </div>
            <div className="col-auto">
              <button className="BotonFiltro" onClick={() => verMenuFiltros()}>
                <img src={filtro} alt="" />{" "}
              </button>
            </div>
          </div>
        </div>

        {!FiltroActivado ? (
          <div
            className="contenedorCiudades"
            onScroll={ScrollDiv}
            ref={contenedorCiudades}
          >
            <div className="">
              {!DetallesActivado ? (
                Locations?.map((mark, index) => (
                  <div
                    className="ItemSucursal row"
                    onClick={ElegirSucursal.bind(this, mark)}
                    key={index}
                  >
                    <div>
                      <img src={Separador} alt="" />
                    </div>
                    <ItemSucursal
                      Datos={mark}
                      ServiciosDat={Servicios}
                      Ciudad={CiudadData}
                      mostrar="show"
                    />
                  </div>
                ))
              ) : (
                <div className="contenedorDetalles">
                  <div>
                    <img
                      src={BotonVolver}
                      alt="Volver"
                      onClick={() => setDetallesActivado(false)}
                    />
                  </div>
                  <ItemDetalles
                    IDPLACE={Detalles.place_id}
                    CiudadConvenioDetalles={Detalles}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="ItemsScroller">
            <div>
              <input
                placeholder="Busca tu Ciudad"
                type="text"
                name="TextFiltro"
                id="TextFiltro"
                onChange={(e) => {
                  setBusquedaCiudad(e.target.value.toUpperCase());
                }}
              />
            </div>
            {FiltroCiudad?.map((Dat) => (
              <div
                className="FiltroCiudad"
                onClick={ElegirCiudad.bind(this, Dat)}
                key={Dat.Ciudad}
              >
                <span style={{ marginLeft: "60px" }}>{Dat.Ciudad}</span>
              </div>
            )).slice(0, 8)}
          </div>
        )}
      </div>

      {/* Navbar (barra búsqueda y filtros)*/}
      <div className="mapaClase">
        <div className="navbar-home">
          <img
            src={logoBU}
            className="img-logo-BU"
            alt="imagen logo Banco Unión"
          />{" "}
        </div>
        <div className="contenedor-buscador" id="contenedor-buscador">
          <button
            className="volver-filtros"
            onClick={() => {
              openItem();
              setDetallesActivado(false);
              ocultarFiltros();
              Quitarfiltros();
            }}
          >
            <img
              src={volverflecha}
              alt="imagen flecha apuntando hacia la izquierda"
            />{" "}
          </button>

          <input
            type="text"
            className="inputBuscarOficinas"
            id="buscarOficinas"
            placeholder="Buscar municipio"
            onChange={(e) => {
              setCiudadBuscada1(e.target.value.toUpperCase());
            }}
          />
          <div className="contenedor-buscar" id="contenedor-buscar">
            <button
              className="boton-buscar"
              id="boton-buscar"
              onClick={(a) => {
                buscarCiudad1(a, ciudadBuscada1);
              }}
            >
              <img src={lupa} alt="imagen lupa" />{" "}
            </button>
          </div>
          <button
            className="boton-filtros"
            onClick={() => {
              verMenuFiltros();
            }}
          >
            <img src={filtro} alt="" />{" "}
          </button>
        </div>
        <div className="dropdown1" id="dropdown1">
          {FiltroCiudad1?.map((Dat) => (
            <div
              className="FiltroCiudad"
              id="FiltroCiudad"
              onClick={ElegirCiudad.bind(this, Dat)}
              key={Dat.Ciudad}
            >
              <span style={{ marginLeft: "60px" }}>{Dat.Ciudad}</span>
            </div>
          )).slice(0, 5)}
        </div>
        <div className="contenedor-filtros" id="contenedor-filtros">
          <div className="input-group mb-3 contenedorBusqueda">
            <input
              type="text"
              id="buscarOficinasFiltros"
              className="inputBuscarOficinasFiltros form-control"
              placeholder="Buscar municipio"
              onChange={(r) => {
                setCiudadBuscada(r.target.value.toUpperCase());
              }}
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              id="button-addon2"
              onClick={(a) => {
                buscarCiudad(a, ciudadBuscada);
              }}
            >
              <img src={lupa2} alt="imagen lupa" />{" "}
            </button>
          </div>
          <div className="dropdown" id="dropdown">
            {FiltroCiudad2?.map((Dat) => (
              <div
                className="FiltroCiudad"
                id="FiltroCiudad"
                onClick={ElegirCiudad.bind(this, Dat)}
                key={Dat.Ciudad}
              >
                <span style={{ marginLeft: "60px" }}>{Dat.Ciudad}</span>
              </div>
            )).slice(0, 5)}
          </div>
          <div className="list-group">
            <label className=" list-group-item contenedor-filtros-checkbox">
              <p className="texto-filtro-categorias">
                Por tipo de establecimiento
              </p>
              <input
                className="form-check-input me-1 checkboxFiltro"
                id="checkboxFiltro"
                type="checkbox"
                value="a1"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              Oficinas Banco Unión
            </label>
            <label className="list-group-item">
              <input
                className="form-check-input me-1 checkboxFiltro"
                type="checkbox"
                id="checkboxFiltro1"
                value="a2"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              Corresponsales
            </label>
          </div>
          <div className="list-group">
            <label className=" list-group-item contenedor-filtros-checkbox">
              <p className="texto-filtro-categorias">
                Por servicios especializados
              </p>
            </label>
            <label className="list-group-item credioro-text">
              <input
                className="form-check-input me-1 checkboxFiltro"
                type="checkbox"
                id="checkboxFiltro2"
                value="b1"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              CrediOro
            </label>
          </div>
          <div className="list-group">
            <label className=" list-group-item contenedor-filtros-checkbox">
              <p className="texto-filtro-categorias">
                Por tipo de corresponsales
              </p>
              <input
                className="form-check-input me-1 checkboxFiltro"
                type="checkbox"
                id="checkboxFiltro3"
                value="c1"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              Efecty
            </label>
            <label className="list-group-item">
              <input
                className="form-check-input me-1 checkboxFiltro"
                type="checkbox"
                id="checkboxFiltro4"
                value="c2"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              Banco Agrario
            </label>
            <label className="list-group-item">
              <input
                className="form-check-input me-1 checkboxFiltro"
                type="checkbox"
                id="checkboxFiltro5"
                value="c3"
                onChange={(a) => {
                  handleChange(a);
                }}
              />
              Multipagas
            </label>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingTop: "2rem",
            }}
          >
            <button
              className="btn btn-primary button-next boton-aplicar"
              type="submit"
              onClick={() => {
                aplicarFiltros();
              }}
            >
              Aplicar
            </button>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingTop: "0.6rem",
            }}
          >
            <button
              className="btn btn-primary button-next boton-aplicar boton-quitar-filtros"
              type="submit"
              onClick={() => {
                Quitarfiltros();
              }}
            >
              Quitar Filtros
            </button>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              paddingTop: "2rem",
            }}
          >
            <button
              className="btn btn-primary button-next boton-cancelar"
              onClick={() => {
                ocultarFiltros();
                Quitarfiltros();
                openItem();
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
      <HomeMap
        centerCity={CiudadData.Coordenadas}
        Marcadores={Locations}
        handleElegirSucursal={ElegirSucursal}
        ciudades={contenedorCiudades}
      />

      <CiudadModal
        show={modalShow}
        handleCiudad={ElegirCiudad}
        dataCities={DataCities}
      />
    </div>
  );
};
